import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';

const styles = () => ({
  root: {},
});

const Subtitle = ({
  className,
  classes,
  text,
  value,
  align,
  color,
  weight,
  test,
}) => {
  return (
    <Text
      className={classNames(classes.root, className)}
      variant={'h6'}
      weight={weight}
      color={color}
      align={align}
      text={value || text}
      test={test}
    />
  );
};

Subtitle.defaultProps = {
  className: '',
  color: 'textSecondary',
  align: 'center',
  weight: 'bold',
  test: undefined,
  text: undefined,
  value: undefined,
};

Subtitle.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  /**
   * @deprecated
   */
  text: PropTypes.string,
  value: PropTypes.string,
  color: PropTypes.string,
  align: PropTypes.string,
  weight: PropTypes.string,
  test: PropTypes.string,
};

export default withStyles(styles)(Subtitle);
